import { SideNav } from "components";
import Card from "components/CardSelector/Card";
import { CardSelectorWrapper } from "components/CardSelector/styles";
import UploadFile from "components/UploadFile";
import {
  BaseDropdown,
  BaseInput,
  LargeButton,
  OverlayLoader,
  PageTitle,
  Ptag,
} from "components/core";
import { FieldArray, Form, Formik } from "formik";
import { startCase, camelCase } from "lodash";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import http from "services/httpService";
import { DisplayName, getFileNameFromUrl } from "utlis/utils";
import {
  PRODUCT_PRICING_VALUES,
  fetchUniversalSetupMasterSelected,
} from "./schema";
import { useNavigate } from "react-router";
import routes from "components/routes";
import { HomeWrapper } from "components/CdBalance/style";
import { colors } from "theme";
import { Button, Divider } from "@mui/material";
import * as Yup from "yup";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import BaseTextArea from "components/BaseTextArea";

const Insurer = () => {
  const navigate = useNavigate();

  const selectedValues = useMemo(() => {
    let selectedValues = localStorage.getItem("eb_selected_values");
    if (selectedValues) {
      selectedValues = JSON.parse(selectedValues);
    }
    return selectedValues;
  }, []);

  const userplanId = useMemo(() => {
    return localStorage.getItem("eb_current_plan");
  }, []);

  const [loading, setLoading] = useState(true);
  const [fileError, setFileError] = useState(false);
  const [rateChartId, setRateChartId] = useState();
  const [selectedProductType, setSelectedProductType] = useState("FLAT");
  const [rateChartLink, setRateChartLink] = useState();
  const [fileDeleted, setFileDeleted] = useState(false);
  const [amountRequired, setAmountRequired] = useState(false);

  const [insurers, setInsurers] = useState([]);
  const [previousRateChartId, setpreviousRateChartId] = useState(selectedValues?.userplans_data?.[userplanId]?.rate_chart_id);
  // Initialize selectedProductType from localStorage on component mount
  useEffect(() => {
    if (userplanId) {
      const savedProductType = localStorage.getItem(`eb_product_type_${userplanId}`);
      if (savedProductType) {
        setSelectedProductType(savedProductType);
      }
    }
  }, [userplanId]);

  // Reset fileDeleted flag when component mounts
  useEffect(() => {
    setFileDeleted(false);
    return () => {
  
      if (amountPerMilTimeoutRef.current) {
        clearTimeout(amountPerMilTimeoutRef.current);
      }
    };
  }, []);

  const isFlex = useMemo(() => {
    if (!selectedValues) return false;
    return selectedValues.flex;
  }, [selectedValues]);

  const productName = useMemo(() => {
    if (!selectedValues || !userplanId) return;
    const name =
      selectedValues.userplans_data[userplanId].product_type.display_name ||
      selectedValues.userplans_data[userplanId].product_type.product_type_name;
    const prouctCode =
      selectedValues?.userplans_data[userplanId]?.product_type
        ?.product_type_name;
    if (prouctCode == "term_life" || prouctCode == "personal_accident")
      setAmountRequired(true);
    return DisplayName(name);
  }, [userplanId, selectedValues]);

  const shouldSetup = (values) => {
    const productDetails = selectedValues.userplans_data[userplanId];
    const prevInsurer = productDetails?.service_provider?.service_provider_id;
    const prevProductType = productDetails?.flat_or_graded;
    const previousRateChart = productDetails?.rate_chart_id;
    if (rateChartId && rateChartId !== previousRateChart) {
      return true;
    }
    if (previousCheck !== (selectedDefault === "YES")) return true;    
    if (values.insurer !== prevInsurer) return true;
        if (selectedProductType !== prevProductType) return true;
    };
  const [selectedDefault, setSelectedDefault] = useState(
  selectedValues?.userplans_data?.[userplanId]?.product_default_selected
    ? "YES"
    : "NO"
);
  const isMandatory = (selectedValues?.userplans_data?.[userplanId]?.mandatory);

  const previousCheck = (selectedValues?.userplans_data?.[userplanId]?.product_default_selected);
  const handleSubmit = async (values) => {
    if (!selectedProductType) return;
    if (!rateChartLink) {
      if (!rateChartId && isFlex && !values.amount_per_mil) return;
    }
    if (!shouldSetup(values)) {
      navigate(`/${routes.GRADE_SETUP}`);
      return;
    }
    setLoading(true);
    let payload = {
      service_provider_id: values.insurer,
      flat_or_graded: selectedProductType,
      rate_chart_id: rateChartId? rateChartId: previousRateChartId,
      userplan_id: userplanId,
      //need to send the true if company is conventional, if flex send the true for mandatory and checked for the voluntary.
      product_default_selected: selectedDefault === "YES" || isMandatory,
    };
    if (values.other_details) {
      const details = values.other_details.filter(val => val);
      if (details.length) {
        payload["other_details"] = values.other_details.filter(val => val)
      }
    }
    if (amountRequired) {
      payload.amount_per_mil = values.amount_per_mil;
    }
    try {
      const { data } = await http.post(
        "/business/setup_insurer_rate_chart_plan/",
        payload
      );
      if (selectedProductType === "PER_EMPLOYEE") {
        navigate(`/${routes.UNIVERSAL_COVERAGE_DOC}`);
      } else {
        navigate(`/${routes.GRADE_SETUP}`);
      }
    } catch (err) {
      alert(err.response.data);
      setRateChartId(null);
      setRateChartLink(null);
      setpreviousRateChartId(null);
      const { data } = await http.get("business/userplans_data_selected/");
      localStorage.setItem("eb_selected_values", JSON.stringify(data));
      console.log(err.response.data)
      alert(err.response.data);
    } finally {
      setLoading(false);
    }
  };

  const initialOptions = ["FLAT", "GRADED"];

  const options = useMemo(() => {
    if (!selectedValues) return initialOptions;
    const prouctCode =
      selectedValues?.userplans_data[userplanId]?.product_type
        ?.product_type_name;
    if (prouctCode == "term_life" || prouctCode == "personal_accident") {
      if(selectedValues.userplans_data[userplanId]?.mandatory){
        initialOptions.push("PER_EMPLOYEE");
      }
    }
    return initialOptions;
  }, [initialOptions, selectedValues]);

  const defaultSelectionOptions = ["YES", "NO"];

  useEffect(() => {
    if (selectedValues && !rateChartLink) {
      setLoading(true);
      setTimeout(() => {
        const currentProductData = selectedValues.userplans_data[userplanId];
        // Check localStorage first, then existing data, then keep current selection
        const savedProductType = localStorage.getItem(`eb_product_type_${userplanId}`);
        if (savedProductType) {
          setSelectedProductType(savedProductType);
        } else if (currentProductData?.flat_or_graded) {
          setSelectedProductType(currentProductData.flat_or_graded);
          // Save the existing data to localStorage for future use
          localStorage.setItem(`eb_product_type_${userplanId}`, currentProductData.flat_or_graded);
        }
        // Only restore rateChartLink if file wasn't explicitly deleted by user
        if (!fileDeleted) {
          setRateChartLink(currentProductData?.rate_chart_link);
        }
        setLoading(false);
      }, 1000);
    }
  }, [selectedValues]);

  useEffect(() => {
    if (!userplanId && insurers.length > 0) return;
    (async function () {
      await fetchUniversalSetupMasterSelected();
      await getInsurerList();
    })();
  }, [userplanId]);

  const getInsurerList = async () => {
    try {
      const { data } = await http.get(
        "/business/service_provider_selectables/",
        {
          params: {
            userplan_id: userplanId,
          },
        }
      );
      if (data && data.length) {
        const dropdownOptions = data.map(
          ({ display_name, name, service_provider_id }) => ({
            label: display_name || name,
            value: service_provider_id,
          })
        );
        setInsurers(dropdownOptions);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const downloadRateChartTemplate = async (values) => {
    if (!values.insurer) {
      alert("Please select insurer!");
      return;
    }
    const payload = {
      userplan_id: userplanId,
      service_provider_id: values.insurer,
    };
    const { data } = await http.post(
      "/business/get_rate_chart_format/",
      payload
    );
    if (data) {
      window.open(data);
    } else {
      alert("No rate chart link found!");
    }
  };

  const handleError = (val) => {
    if (!rateChartId && isFlex && !val.amount_per_mil) {
      setFileError(true);
    }
    if (!selectedProductType) {
      alert("Please select the product type");
    }
  };

  // const initialValues = useMemo(() => {
  //   return {
  //     ...PRODUCT_PRICING_VALUES,
  //     insurer:
  //       selectedValues?.userplans_data[userplanId]?.service_provider
  //         ?.service_provider_id,
  //     amount_per_mil: "",
  //   };
  // }, [selectedValues]);
  const initialValues = useMemo(() => {
    const updatedValues = {
      ...PRODUCT_PRICING_VALUES,
      insurer:
        selectedValues?.userplans_data[userplanId]?.service_provider
          ?.service_provider_id || "",
    };

    if (amountRequired) {
      updatedValues.amount_per_mil =
        selectedValues?.userplans_data[userplanId]?.amount_per_mil;
    }

    return updatedValues;
  }, [selectedValues, amountRequired]);

  const handleProductTypeSelection = (display_name) => {
    setSelectedProductType(display_name);
    setRateChartLink(null);
    // Persist selection to localStorage
    localStorage.setItem(`eb_product_type_${userplanId}`, display_name);
  };

  const handleDefaultSelection = (value) => {
  setSelectedDefault(value);
};

  const handleDeleteRateChart = async (values) => {
    try {
      const payload = {
        service_provider_id: values.insurer,
        flat_or_graded: selectedProductType,
        rate_chart_id: null, 
        userplan_id: userplanId,
      };
      
      if (values.other_details) {
        const details = values.other_details.filter(val => val);
        if (details.length) {
          payload["other_details"] = values.other_details.filter(val => val);
        }
      }
      
      if (amountRequired) {
        payload.amount_per_mil = values.amount_per_mil;
      }

      await http.post("/business/setup_insurer_rate_chart_plan/", payload);
      console.log("Rate chart deleted successfully");
    } catch (err) {
      console.log("Error deleting rate chart:", err);
    }
  };

  // Refs for debouncing amount_per_mil changes
  const amountPerMilTimeoutRef = useRef(null);
  const previousAmountPerMilRef = useRef(null);

  // Handler to auto-save amount_per_mil when it changes
  const handleAmountPerMilChange = useCallback(async (values) => {
    if (!amountRequired || !values.insurer || !selectedProductType) return;
    
    const payload = {
      service_provider_id: values.insurer,
      flat_or_graded: selectedProductType,
      rate_chart_id: rateChartId,
      userplan_id: userplanId,
    };
    
    if (values.other_details) {
      const details = values.other_details.filter(val => val);
      if (details.length) {
        payload["other_details"] = values.other_details.filter(val => val);
      }
    }
    
    if (amountRequired) {
      payload.amount_per_mil = values.amount_per_mil || null;
    }

    try {
      await http.post("/business/setup_insurer_rate_chart_plan/", payload);
      // Refresh the selected values after updating
      await fetchUniversalSetupMasterSelected();
    } catch (err) {
      console.log("Error auto-saving amount_per_mil:", err);
    }
  }, [amountRequired, selectedProductType, rateChartId, userplanId]);

  const insurerValidationSchema = Yup.object().shape({
    insurer: Yup.string().required("*Required"),
  });

  return loading ? (
    <OverlayLoader />
  ) : (
    <>
      <SideNav />
      <HomeWrapper style={{}}>
        <PageTitle title={`Setup ${productName}`} />
        <WidthLimiter>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={insurerValidationSchema}
            onSubmit={handleSubmit}
          >
            {(formikProps) => {
              // Track previous value on initial render
              if (previousAmountPerMilRef.current === null) {
                previousAmountPerMilRef.current = formikProps.values.amount_per_mil;
              }

              // Wrap handleChange to intercept amount_per_mil changes
              const originalHandleChange = formikProps.handleChange;
              const wrappedHandleChange = (e) => {
                // Call original handler first
                originalHandleChange(e);
                
                // If this is the amount_per_mil field, trigger auto-save
                if (e.target.name === "amount_per_mil") {
                  // Clear existing timeout
                  if (amountPerMilTimeoutRef.current) {
                    clearTimeout(amountPerMilTimeoutRef.current);
                  }
                  
                  // Debounce the API call (wait 1 second after user stops typing)
                  const newValue = e.target.value;
                  amountPerMilTimeoutRef.current = setTimeout(() => {
                    // Use current formikProps.values at the time of timeout execution
                    const updatedValues = {
                      ...formikProps.values,
                      amount_per_mil: newValue,
                    };
                    handleAmountPerMilChange(updatedValues);
                  }, 1000);
                }
              };

              // Create wrapped formikProps with custom handleChange
              const wrappedFormikProps = {
                ...formikProps,
                handleChange: wrappedHandleChange,
              };

              return (
              <Form style={{ paddingBottom: "80px", paddingTop: "24px" }}>
                <BaseDropdown
                  staticLabel="Choose Insurer"
                  fontSize="14px"
                  options={insurers}
                  formikProps={{ ...formikProps, name: "insurer" }}
                />
                <Ptag
                  color={colors.primaryColor}
                  fontSize="14px"
                  marginBottom="10px"
                  marginTop="calc(51px - 16px)"
                >
                  Choose Type
                </Ptag>
                <CardSelectorWrapper>
                  {options.map((display_name, index) => (
                    <Card
                      key={index}
                      title={startCase(camelCase(display_name))}
                      selected={selectedProductType === display_name}
                      onChange={() => handleProductTypeSelection(display_name)}
                    />
                  ))}
                </CardSelectorWrapper>
                {selectedProductType === "PER_EMPLOYEE" && (
                  <div>
                    <Ptag
                      color={colors.primaryColor}
                      fontSize="14px"
                      marginBottom="10px"
                      marginTop="calc(51px - 16px)"
                    >
                      Coverage Notes (optional)
                    </Ptag>
                    <FieldArray
                      name="other_details"
                      render={(arrayHelpers) => (
                        <div>
                          {formikProps.values.other_details &&
                            formikProps.values.other_details.map((_, index) => (
                              <div
                                key={index}
                                style={{
                                  marginBottom: "0.4rem",
                                }}
                              >
                                <BaseTextArea name={`other_details.${index}`} />
                              </div>
                            ))}
                          <footer
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            {formikProps.values.other_details.length > 1 && (
                              <Button
                                sx={{
                                  fontSize: "14px !important",
                                  textDecoration: "underline",
                                  textTransform: "capitalize",
                                  color: "#DE6944",
                                }}
                                startIcon={<RemoveCircleOutlineIcon />}
                                onClick={() =>
                                  arrayHelpers.remove(
                                    formikProps.values.other_details.length - 1
                                  )
                                }
                              >
                                Remove
                              </Button>
                            )}
                            <Button
                              sx={{
                                fontSize: "14px !important",
                                textDecoration: "underline",
                                textTransform: "capitalize",
                                color: colors.primaryColor,
                              }}
                              startIcon={<ControlPointIcon />}
                              onClick={() => arrayHelpers.push("")}
                            >
                              Add
                            </Button>
                          </footer>
                        </div>
                      )}
                    />
                  </div>
                )}

                {!isMandatory && (
                    <div style={{ marginTop: "calc(51px - 16px)" }}>
                      <Ptag
                        color={colors.primaryColor}
                        fontSize="14px"
                        marginBottom="10px"
                      >
                        Pre-select for Employees
                      </Ptag>

                      <CardSelectorWrapper>
                        {defaultSelectionOptions.map((option, index) => (
                          <Card
                            key={index}
                            title={startCase(camelCase(option))}
                            selected={selectedDefault === option}
                            onChange={() => handleDefaultSelection(option)}
                          />
                        ))}
                      </CardSelectorWrapper>
                    </div>)}

                <div style={{ marginTop: "4rem" }}>
                  <UploadFile
                    description="Price chart will be required to view premium estimates for endorsements"
                    label={`Upload Pricing ${!isFlex ? "(optional)" : ""}`}
                    text="Upload Excel"
                    format="excel"
                    onDownload={() =>
                      downloadRateChartTemplate(formikProps.values)
                    }
                    existingFileName={
                      rateChartLink && getFileNameFromUrl(rateChartLink)
                    }
                    isDisabled={formikProps.values?.amount_per_mil}
                    type="policy_document"
                    onSelect={(fileId) => {
                      setRateChartId(fileId);
                      if (!fileId) {
                        // Clear rateChartLink when file is deleted
                        setRateChartLink(null);
                        setFileDeleted(true);
                        // Call API with rate_chart_id: null when delete icon is clicked
                        handleDeleteRateChart(formikProps.values);
                      } else {
                        setFileDeleted(false);
                      }
                    }}
                    showError={fileError}
                    sampleFile="FlexRateChart"
                  />
                </div>
                {amountRequired && (
                  <>
                    <Divider style={{ paddingBottom: "30px" }}>
                      <Ptag fontSize="14px">Or</Ptag>
                    </Divider>
                    <BaseInput
                      staticLabel="Amount Per Mil"
                      disabled={rateChartId}
                      fontSize="16px !important"
                      formikProps={{ 
                        ...wrappedFormikProps, 
                        name: "amount_per_mil"
                      }}
                    />
                  </>
                )}
                <div
                  style={{

                    display: "flex",
                    position: "absolute",
                    width: "920px",

                  }}
                >
                  <LargeButton
                    type="submit"
                    label="Save & Next"
                    marginTop="3rem"
                    disabled={
                      !formikProps.values.insurer && !(formikProps.dirty && formikProps.isValid)
                    }
                    opacity={
                      !formikProps.values.insurer && !(formikProps.dirty && formikProps.isValid)
                        ? 0.6
                        : 1
                    }
                    onClick={() => handleError(formikProps.values)}
                  />
                </div>
              </Form>
              );
            }}
          </Formik>
        </WidthLimiter>
      </HomeWrapper>
    </>
  );
};

export default Insurer;
